import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=fd8a1222&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=ts&"
export * from "./Cookies.vue?vue&type=script&lang=ts&"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=fd8a1222&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8a1222",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VCard,VCardText,VCardTitle,VIcon})
